import { fetchAuthSession } from 'aws-amplify/auth'
import { Buffer } from 'buffer'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RelayEnvironmentProvider } from 'react-relay'
import './index.css'
import GlobalProvider from './providers/global-provider/global-provider'
import RelayEnvironment from './relay-environment'
import routes from './routes'
import createRouter from './routes/create-router'
import RouterRenderer from './routes/route-renderer'
import RoutingContext from './routes/routing-context'
import { deleteCookie, setCookie } from './utils'
import { configureAmplify } from './utils/amplify-configure'

// Shim Node globals in browser
window.global = window;
if (!window.Buffer) {
  window.Buffer = Buffer;
}

configureAmplify()

// Uses the custom router setup to define a router instanace that we can pass through context
const router = createRouter(routes)

const render = () => createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RelayEnvironmentProvider environment={RelayEnvironment}>
      <RoutingContext.Provider value={router.context}>
        <GlobalProvider>
          {/* RouteRenderer will render the routes defined in the route.tsx configuration file, including the App component and other related components. */}
          <RouterRenderer />
        </GlobalProvider>
      </RoutingContext.Provider>
    </RelayEnvironmentProvider>
  </StrictMode>
)

// Keep in sync with setCookies() in amplify-parts.ts
fetchAuthSession()
  .then(({ tokens: session }) => {
    const isAuthenticated = !!session;
    localStorage.setItem('authenticated', isAuthenticated.toString());

    if (isAuthenticated) {
      const userId = session.idToken?.payload?.sub || session.accessToken?.payload?.sub;

      if (userId) {
        localStorage.setItem('p_tguid', userId);
        localStorage.setItem('p_tguid_updated_at', Date.now().toString());
        setCookie('idToken', `${session.idToken}`, 0.5)
        setCookie('accessToken', `${session.accessToken}`, 0.5)
        deleteCookie('docu.idToken')
      }
    }
  })
  .catch(() => {
    localStorage.setItem('authenticated', 'false');
    deleteCookie('idToken')
    deleteCookie('accessToken')
    deleteCookie('docu.idToken')
  })
  .finally(() => {
    render();
  });
